import { createContext, useContext, useState, useEffect } from "react";

const LanguageContext = createContext(null);
export const useLang = () => useContext(LanguageContext);

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("thrm_lang") || "nl");
  useEffect(() => { localStorage.setItem("thrm_lang", lang); }, [lang]);
  const toggle = () => setLang((l) => (l === "nl" ? "en" : "nl"));
  const t = (nl, en) => (lang === "en" ? en : nl);
  return <LanguageContext.Provider value={{ lang, toggle, t }}>{children}</LanguageContext.Provider>;
}
